const INFO = {
	main: {
		title: "Viswa's Portfolio",
		name: "Viswa Kotra",
		email: "viswaretaskotra@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		// twitter: "https://twitter.com/",
		github: "https://github.com/vk1815918",
		linkedin: "https://www.linkedin.com/in/viswa-kotra/",
		// instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/users/15442544/transparent-coder",
		// facebook: "https://facebook.com/",
	},

	homepage: {
		title: "👋 Hello! I'm Viswa 🤠",
		description:
			"I'm a software developer specializing in AI/ML, Quantitative Finance, and Blockchain Technology. I have a strong interest in startups and entrepreneurship. I am constantly working on new projects, which you can explore in the projects section. Feel free to reach out to me; I'd welcome the opportunity to take a break from my work and connect."
	},	

	about: {
		title: "About Me",
		description:
			"I've worked on many projects, many of which are open-source. Feel free to explore, contribute, and suggest improvements. Collaboration helps me learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about innovation and inspiring future innovators.",
		description:
			"Articles and blog posts that I've written and been featured in. I write about technology, startups, and my journey as a software developer.",
	},

	projects: [
		{
			title: "Blockchain-Based-Federated-Learning-Optimization",
			description:
				"Federated Learning, a decentralized machine learning approach, has advanced significantly. However, integrating it with blockchain faces challenges, particularly with high gas fees and slow epochs. Our research addresses this by combining blockchain with federated learning and optimizing this conjunction using various tree structures and off-chain computing. ",
			logo: "https://icons.veryicon.com/png/o/business/bitcoin-icon/blockchain-1.png",
			linkText: "View Project",
			link: "https://github.com/ACM-Research/Blockchain-Based-Federated-Learning-Optimization",
		},

		{
			title: "ChurnGuard",
			description:
				"ChurnGuard is designed to help banks lock in customer loyalty. The platform offers insights into a bank’s customer retention & the factors behind their churning. Then, given a customer being considered by bank employee & some basic information about the customer, we can predict the probability of churn and classify whether the customer is going to churn in the near future.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/vk1815918/ChurnGuard",
		},

		{
			title: "GBM-Trees-for-Crypto-Forecasting",
			description:
				"We use Gradient Boosted Trees for directional forecasting of the next minutely candlestick. It uses 60+ Technical indicators and using feature engineering standardizes the indicators to attain optimal parameters. The data used can be accessed and downloaded on the Binance historical data site.",
			logo: "https://www.pngmart.com/files/3/Stock-Market-Transparent-PNG.png",
			linkText: "View Project",
			link: "https://github.com/vk1815918/GBM-Trees-for-Crypto-Forecasting",
		},

		{
			title: "React-Website-Framework",
			description:
				"This is a basic website template created using React Typescript framework. It is a simple and elegant design that can be used for any kind of website. It is responsive, fast, and easy to use.",
			logo: "https://pluspng.com/img-png/react-logo-png-img-react-logo-png-react-js-logo-png-transparent-png-1142x1027.png",
			linkText: "View Project",
			link: "https://github.com/vk1815918/React-Website-Template",
		},

		{
			title: "L2-Orderbook-data-formatting",
			description:
				"L2 Orderbook is sourced from Cryptofeed library's BinanceUS websocket. The data is then transformed into a pandas dataframe and printed out with an optional choice of visualizing the orderbook at every update.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/vk1815918/L2-Orderbook-data-formatting",
		},

		
	],
};

export default INFO;
